"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTZ = exports.format = exports.calculateTimezoneOffset = exports.formattedShortDateByTimezone = exports.formattedDateByTimezone = exports.formattedDateWithTime = exports.formattedShortDate = exports.formattedDate = exports.convertDateByTimezone = void 0;
var date_1 = require("./date");
Object.defineProperty(exports, "format", { enumerable: true, get: function () { return date_1.format; } });
Object.defineProperty(exports, "convertTZ", { enumerable: true, get: function () { return date_1.convertTZ; } });
Object.defineProperty(exports, "calculateTimezoneOffset", { enumerable: true, get: function () { return date_1.calculateTimezoneOffset; } });
var SHORT_DAY_NAME_DAY_MONTH = 'ddd, d mmm';
var DATE_TIME_FORMAT = 'ddd, dd mmm, yyyy - h:MMtt';
var DATE_FORMAT = 'ddd, dd mmm, yyyy';
var convertDateByTimezone = function (date, timezone) { return date_1.convertTZ(date, timezone); };
exports.convertDateByTimezone = convertDateByTimezone;
var formattedDateWithTime = function (date) { return date_1.format(date, DATE_TIME_FORMAT); };
exports.formattedDateWithTime = formattedDateWithTime;
var formattedDate = function (date) { return date_1.format(date, DATE_FORMAT); };
exports.formattedDate = formattedDate;
var formattedShortDate = function (date) { return date_1.format(date, SHORT_DAY_NAME_DAY_MONTH); };
exports.formattedShortDate = formattedShortDate;
var formattedDateByTimezone = function (date, timezone) {
    if (typeof date === 'string' && date.indexOf('T00:00:00.000Z') !== -1) {
        return formattedDate(new Date(date)) + " - 11:59pm";
    }
    var dateForConverting = new Date(date);
    if (timezone) {
        dateForConverting = convertDateByTimezone(dateForConverting, timezone);
    }
    return formattedDateWithTime(dateForConverting);
};
exports.formattedDateByTimezone = formattedDateByTimezone;
var formattedShortDateByTimezone = function (date, timezone) {
    if (typeof date === 'string' && date.indexOf('T00:00:00.000Z') !== -1) {
        return formattedShortDate(new Date(date));
    }
    var dateForConverting = new Date(date);
    if (timezone) {
        dateForConverting = convertDateByTimezone(dateForConverting, timezone);
    }
    return formattedShortDate(dateForConverting);
};
exports.formattedShortDateByTimezone = formattedShortDateByTimezone;
